module.exports = __webpack_public_path__ + "img/close.00e8092c.svg";